module.exports = __webpack_public_path__ + "img/sea_breeze.dce56174.jpg";